<template>
    <!--  拖拽功能  -->
    <div class="drogger" style="width: 100%;background-color: #f0f2f5;" :style="'minHeight:' + height +'px' ">
        <grid-layout
                v-if="layoutInfo.length!=0"
                :layout="layoutInfo"
                :auto-size="true"
                :col-num="20"
                :row-height="50"
                :max-rows="100"
                :is-draggable="true"
                :is-resizable="true"
                :vertical-compact="true"
                :is-mirrored="false"
                :margin="[10, 10]"
                :use-css-transforms="true">
            <grid-item v-for="(item, index) in layoutInfo" :key="item.i"
                       :min-w="6"
                       :min-h="6"
                       :x="item.x"
                       :y="item.y"
                       :w="item.w"
                       :h="item.h"
                       :i="item.i"
                       :heightFromChildren="true"
                       @resize="resizeEventBig"
                       @move="moveEventBig"
                       @resized="resizedEventBig"
                       @moved="movedEventBig"
                       style="border: 1px solid #E8E8E8;background-color: #fff" class="item-contentTest"  v-loading="loading">
<!--                <template v-for="(one, key) in objArr">-->
                <el-row class="bigTitletop">
                    <div class="chart-title">{{ item.name}}</div>
                    <div class="button-content" style="position: absolute;top: 0px;right: 5px;cursor: pointer">
                        <el-dropdown>
                              <span class="el-dropdown-link">
                                  <i class="el-icon-more" style="margin-left: 5px;margin-right: 10px"></i></span>
                            <el-dropdown-menu slot="dropdown" style="margin-top: 0px">
                                <!--表格-->
                                <el-dropdown-item
                                        @click.native="chooseType('table', item, index)"
                                        :disabled="item.ObjDate.hasTable === 0 ? true : false">
                                    <i
                                            :class="(item.showType === '' ? (item.ObjDate.defaultShow === 'table') : (item.showType === 'table')) ? 'icon-blue' : 'icon-black'"
                                            class="analyse-res-icon iconfont icon-wenbenjieguo-1">
                                    </i>
                                </el-dropdown-item>
                                <!--饼-->
                                <el-dropdown-item
                                        @click.native="chooseType('pieChart', item, index)"
                                        :disabled="item.ObjDate.hasPieChart === 0 ? true : false">
                                    <i
                                            :class="(item.showType === '' ? (item.ObjDate.defaultShow === 'pieChart') : (item.showType === 'pieChart')) ? 'icon-blue' : 'icon-black'"
                                            class="analyse-res-icon icon-bingzhuangtu-1 iconfont">
                                    </i>
                                </el-dropdown-item>
                                <!--线-->
                                <el-dropdown-item
                                        @click.native="chooseType('lineChart', item, index)"
                                        :disabled="item.ObjDate.hasLineChart === 0 ? true : false">
                                    <i :class="(item.showType === '' ? (item.ObjDate.defaultShow === 'lineChart') : (item.showType === 'lineChart')) ? 'icon-blue' : 'icon-black'" class="analyse-res-icon icon-zhexiantu- iconfont">
                                    </i>
                                </el-dropdown-item>
                                <!--柱-->
                                <el-dropdown-item
                                        @click.native="chooseType('barGraph', item, index)"
                                        :disabled="item.ObjDate.hasBarGraph === 0 ? true : false">
                                    <i :class="(item.showType === '' ? (item.ObjDate.defaultShow === 'barGraph') : (item.showType === 'barGraph')) ? 'icon-blue' : 'icon-black'"
                                       class="iconfont icon-zhuzhuangjieguo-1 analyse-res-icon">
                                    </i>
                                </el-dropdown-item>
                                <!--数字-->
                                <el-dropdown-item
                                        @click.native="chooseType('singleMetric', item, index)"
                                        :disabled="item.ObjDate.hasSingleMetric === 0 ? true : false">
                                    <i class="iconfont icon-shuzijieguo-1 analyse-res-icon"
                                       :class="(item.showType === '' ? (item.ObjDate.defaultShow === 'singleMetric') : (item.showType === 'singleMetric')) ? 'icon-blue' : 'icon-black'">
                                    </i>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-row>
                <div >
                    <div class="bigCont" :class="'chartInfo' + index" v-show="item.showType === 'lineChart' || item.showType === 'barGraph' || item.showType === 'pieChart'">
                        <div :ref="'bigCont'+ item.i" :id="'bigCont' + item.i"></div>
                    </div>
                    <div class="bigCont" :class="'Number' + index"
                         v-show="item.showType === 'singleMetric'" >
                        <div :ref="'bigContSum'+ item.i" :id="'bigCont' + item.i" >
                            <div class="singleNum">
                                <div class="singleNum_2">{{item.ObjDate.singleMetric}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 右小角 拖拽-->
                    <div class="fixIcone">
                        <img src = '../../../assets/images/icn_2.png'>
<!--                        <span class="el-icon-rank"></span>-->
                    </div>
                    <div class="bigCont" :class="'TableInfo'+ index"
                         v-show="item.showType === 'table'">
                        <div  :id="'bigCont' + item.i" class="table-div"
                              :ref="'bigContTable'+ item.i" >
                            <el-table :data="item.ObjDate.tableData.showTableObj" width="100%">
                                <el-table-column
                                        v-for="(it, ind) in item.ObjDate.tableData.columns"
                                        :key="ind"
                                        :label="it.title">
                                    <template slot-scope="scope">
                                        {{scope.row[it.dataIndex]}}
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagetion" v-if="item.ObjDate.tableData.total!=1 && item.ObjDate.tableData.total!=0">
                                <span @click="changePage(0, item.ObjDate)" class="pagetion_1 el-icon-caret-left"
                                      :class="pageTable===1?'nojian':''"></span>
                                <span class="pagetion_2">{{pageTable}}/{{item.ObjDate.tableData.total}}</span>
                                <span @click="changePage(1, item.ObjDate)" class="pagetion_1 el-icon-caret-right"
                                      :class="pageTable===item.ObjDate.tableData.total?'nojian':''"></span>
                            </div>

<!--                                <a-locale-provider :locale="zhCN">-->
<!--                                    <a-table-->
<!--                                            class="board-table"-->
<!--                                            :pagination="{-->
<!--                          total: item.ObjDate.tableData.total || 0,-->
<!--                          defaultCurrent: page,-->
<!--                          pageSize: 6,-->
<!--                          size: 'small',-->
<!--                          hideOnSinglePage: true,-->
<!--                          showQuickJumper: false,-->
<!--                          showSizeChanger: false,-->
<!--                          showTotal: function (total) { // 设置显示一共几条数据-->
<!--                            return '共 ' + total + ' 条'-->
<!--                          }-->
<!--                        }"-->
<!--                                            :columns="item.ObjDate.tableData.columns"-->
<!--                                            :dataSource="item.ObjDate.tableData.tableData">-->
<!--                                    </a-table>-->
<!--                                </a-locale-provider>-->
                        </div>
                    </div>
                </div>
            </grid-item>
        </grid-layout>
        <div v-if="layoutInfo.length ==0">
            <div class="board_blank" @click="addSingleChartActionBig">
                <div>
                    <div><i class="el-icon-circle-plus-outline" title="添加单图"
                    ></i></div>
                    <div>
                        <span>添加单图</span></div>
                </div>
            </div>
        </div>
    </div>
    <!-- 渲染图表功能  -->
</template>

<script>
  import { Table, LocaleProvider } from 'ant-design-vue'
import VueGridLayout from 'vue-grid-layout'
Vue.use(VueGridLayout)
var GridLayout = VueGridLayout.GridLayout
var GridItem = VueGridLayout.GridItem
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'boardChart',
  props:['dataArr', 'objArr'],
  data (){
    return {
      pageTable: 1,
      height: window.innerHeight,
      loading: false,
      layoutInfo: [],
      count: 10,
      total: 0,
      page: 1,
      zhCN,
    }
  },
  components: {
    GridLayout,
    GridItem,
    ATable: Table,
    ALocaleProvider: LocaleProvider
  },
  methods:{
    // 获取指定开始到结束下标的，数组内容
    getArrCont(start,end,arr){
      let newarr = []
      arr.map(function(item,index){
        if(index>=start && index < end) {
          newarr.push(item)
        }
      })
      return newarr
    },
    changePage (type, one) {
      if(type == 0) {
        if(this.pageTable>1) {
          let start = (this.pageTable-2) * 10
          let end = (this.pageTable-1) * 10
          this.pageTable = this.pageTable - 1
          let newObj = this.getArrCont(start,end,one.tableData.tableData)
          this.objArr[one.figureId].tableData.showTableObj = newObj
        }

      } else {
        let start = this.pageTable * 10
        let end = (this.pageTable+1) * 10
        if(this.pageTable<one.tableData.total) {
          this.pageTable = this.pageTable + 1
          let newObj = this.getArrCont(start,end,one.tableData.tableData)
          this.objArr[one.figureId].tableData.showTableObj = newObj
        }


      }
    },
    addSingleChartActionBig(){
      this.$emit("addSingleChartAction")
    },
    resizeEventBig(i, newH, newW, newHPx, newWPx){

    },
    moveEventBig() {},
    resizedEventBig(i, newH, newW, newHPx, newWPx) {
      let that = this
      let bigCont = 'bigCont' + i
      let chartRef = that.$refs[bigCont]
      let width = newWPx-60
      let height = newHPx-60
      chartRef[0].style.width = width + 'px'
      chartRef[0].style.height = height + 'px'
      let index = -1
      this.layoutInfo.map(function(item, ind) {
        if(item.i === i) {
          // 获取当前
          index = ind
        }
      })
      if(this.layoutInfo[index].showType === 'table') {
        let bigContTable = 'bigContTable'+ i
        let table = that.$refs[bigContTable]
        table[0].style.maxHeight = (height) + 'px'
        table[0].style.width = (width+38) + 'px'
        table[0].style.height = (height) + 'px'
      }
      if(this.layoutInfo[index].showType === 'singleMetric') {
        let bigContSum = 'bigContSum'+ i
        let num = that.$refs[bigContSum]
        num[0].style.width = width + 'px'
        num[0].style.height = height + 'px'
      }
      this.layoutInfo[index].widthPX = width
      this.layoutInfo[index].ObjDate.widthPX = width
      this.layoutInfo[index].heightPX = height
      this.layoutInfo[index].ObjDate.heightPX = height
      this.chooseType(this.layoutInfo[index].showType, this.layoutInfo[index], index, 1)
    },
    movedEventBig() {},
    chooseType(type, item, index, dray){
      let that = this
      let name = 'TableInfo'+ index
      let name1 = 'chartInfo'+ index
      let name2 = 'Number'+ index
      let bigCont = 'bigCont' + item.i
      this.layoutInfo[index].showType = type
      if(type === 'barGraph' || type === 'lineChart' || type === 'pieChart'){
        // document.getElementsByClassName(name1).style.display = 'block'
        // document.getElementsByClassName(name).style.display = 'none'
        // document.getElementsByClassName(name2).style.display = 'none'
      }
      if(type === 'singleMetric') {
         document.getElementsByClassName(name).style.display = 'block'
         document.getElementsByClassName(name1).style.display = 'none'
         document.getElementsByClassName(name2).style.display = 'none'
      } else if(type === 'barGraph'){
        // 柱状图
        that.barGraphBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate)
      } else if(type === 'lineChart'){
        // 折线
        that.LineChartBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate)
      } else if(type === 'pieChart'){
        // 饼图
        that.PieBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate, index, dray)
      } else if(type === 'table') {
        let bigContTable = 'bigContTable'+ item.i
        let table = that.$refs[bigContTable]
        //计算表格总条数，每页显示数据，当前页
        let tableObj = this.layoutInfo[index].ObjDate
        let total = Math.ceil(tableObj.tableData.tableData.length/10)
        tableObj.tableData.total = total
        let showTableObj =  this.getArrCont(0,10,tableObj.tableData.tableData)
        tableObj.tableData.showTableObj = showTableObj

        table[0].style.maxHeight = item.ObjDate.heightPX + 'px'
        table[0].style.height = item.ObjDate.heightPX  + 'px'
        document.getElementsByClassName(name).style.display = 'block'
        document.getElementsByClassName(name1).style.display = 'none'
        document.getElementsByClassName(name2).style.display = 'none'

      }
    },
    // 计算默认尺寸
    readyRender() {
      let that = this
      this.$nextTick(() => {
        this.layoutInfo.map(function(item, index) {
          let bigCont = 'bigCont' + item.i
          let chartRef = that.$refs[bigCont]
          let width = (parseInt(chartRef[0].parentNode.parentNode.parentNode.style.width)-60)
          let height = (parseInt(chartRef[0].parentNode.parentNode.parentNode.style.height)-60)
          chartRef[0].style.width = width + 'px'
          chartRef[0].style.height = height + 'px'
          item.ObjDate.widthPX = width
          item.ObjDate.heightPX = height
          if (item.showType === "singleMetric") {
            // 数字
            let bigContSum = 'bigContSum'+ item.i
            let num = that.$refs[bigContSum]
            num[0].style.width = width + 'px'
            num[0].style.height = height + 'px'
            document.getElementById('bigCont' + item.i).style.height = height
          } else if (item.showType === "barGraph") {
            // 柱状图
            that.barGraphBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate)
          } else if(item.showType === "lineChart") {
            // 折线
            that.LineChartBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate)
          } else if(item.showType === "pieChart") {
            // 饼图
            that.PieBig(bigCont, item.ObjDate.barLinePieData.valueList, item.ObjDate, index)
          } else if(item.showType === 'table') {
            // 计算表格数据
            let bigContTable = 'bigContTable'+ item.i
            let table = that.$refs[bigContTable]
            table[0].style.maxHeight = (height) + 'px'
            table[0].style.width = (width+38) + 'px'
            table[0].style.height = (height) + 'px'

          }
        })
      })
    },
    // 渲染柱状图
    barGraphBig(id, data, item) {
      let size = 20
      if(item.widthPXB< 300) {
        size = 15
      }
      document.getElementById(id).innerHTML = ''
      if(data.length> 6) {
        const columnPlot = new G2Plot.Column(document.getElementById(id), {
          title: {
            visible: false,
            text: '',
          },
          description: {
            visible: false,
            text: '',
          },
          width: item.widthPX,
          height: item.heightPX,
          adjustPosition: true,
          forceFit: true,
          data,
          padding: 'auto',
          meta: {
            x: {
              alias:item.barLinePieData.xName,
            },
            y: {
              alias: item.barLinePieData.yName,
            }
          },
          xField: "x",
          xAxis: {
            line: {
              visible: true
            },
            visible: true,
            label: {
              autoHide: true,
              autoRotate: false,
            },
          },
          yAxis: {
            visible: true,
            label: {
              visible: true,
              formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
          },
          yField: "y",
        });
        columnPlot.render()
      }  else {
        let data1 = []
        data.map(function(ite,ind){
          data1.push({
            type: ite.x,
            value: ite.y
          })
        })
        const chart = new G2.Chart({
          container: id,
          autoFit: true,
          width:  item.widthPX,
          height: item.heightPX,
          padding: 'auto',
        });
        chart.data(data1);
        chart.scale('value', {
          alias: item.barLinePieData.yName,
          nice: false,
        });

        chart.axis('type', {
          tickLine: {
            alignTick: false,
          },
        });
        chart.axis('value', {
          label: {
            formatter: (val) => {
              return val
            },
          },
        })
        chart.axis('value', {
          position: 'left',
          title: {
            autoRotate: true, // 是否需要自动旋转，默认为 true
            offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
            // 设置标题的文本样式
            textStyle: {
              textAlign: 'center', // 文本对齐方向，可取值为： start middle end
              fill: '#404040', // 文本的颜色
              fontSize: '12', // 文本大小
              fontWeight: 'bold', // 文本粗细
              rotate: 90, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
              textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
            },
            text: item.barLinePieData.yName,
            position:  'top'
          }
        })
        chart.axis('type', {
          label: {
            formatter: (val) => {
              return val
            },
            offsetY: 20,
            autoRotate: false,
          },
          title: {
            autoRotate: false, // 是否需要自动旋转，默认为 true
            offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
            // 设置标题的文本样式
            textStyle: {
              textAlign: 'center', // 文本对齐方向，可取值为： start middle end
              fill: '#404040', // 文本的颜色
              fontSize: '12', // 文本大小
              fontWeight: 'bold', // 文本粗细
              rotate: 30, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
              textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
            },
            text: item.barLinePieData.xName,
            position:  'center'
          }
        });
        chart.legend(false)
        chart.tooltip({
          showTitle: true,
          title:'type',
          showMarkers: false,
          itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" ' +
            'class="g2-tooltip-marker"></span>{value1}<span class="g2-tooltip-value"></span></li>',
        });
        chart.interval().position('type*value').size(size).color('type', (val) => {
          return '#1980FF'
        }).tooltip('type*value', (type, value) => {
          value = item.barLinePieData.yName + '：' + value
          return {
            value1: value,
          }
        })
          .label('value', {
            content: (originData) => {
              const val = parseFloat(originData.value)
              if (val < 0.05) {
                return (val * 100).toFixed(1)
              }
            },
            offset: 12,
          });
        chart.render();
      }
    },
    // 渲染折线图
    LineChartBig(id, data, item) {
      document.getElementById(id).innerHTML = ''
      document.getElementById(id).innerHTML = ''
      // 面积图
      const chart = new G2.Chart({
        container: id,
        autoFit: true,
        width: item.widthPXL,
        height: item.heightPXL,
      });

      chart.data(data);
      chart.scale({
        y: {
          min: 0,
          nice: true,
        },
        x: {
          range: [0, 1],
        },
      });
      chart.axis('y', {
        line: {
          stroke: '#808080',
          lineWidth: 1,
        },
        position: 'left',
        title: {
          autoRotate: true, // 是否需要自动旋转，默认为 true
          offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
          // 设置标题的文本样式
          textStyle: {
            textAlign: 'center', // 文本对齐方向，可取值为： start middle end
            fill: '#404040', // 文本的颜色
            fontSize: '12', // 文本大小
            fontWeight: 'bold', // 文本粗细
            rotate: 90, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
            textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
          },
          text: item.barLinePieData.yName,
          position:  'top'
        }
      })

      // chart.tooltip({
      //   showCrosshairs: true,
      //   shared: true,
      // });
      chart.tooltip({
        showCrosshairs: true,
        shared: true,
        showTitle: true,
        title:'x',
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" ' +
          'class="g2-tooltip-marker"></span>{value}<span class="g2-tooltip-value"></span></li>',
      });

      chart.axis('x', {
        label: {
          formatter: (val) => {
            return val
          },
          offsetY: 20,
          autoRotate: false,
        },
        title: {
          autoRotate: false, // 是否需要自动旋转，默认为 true
          offset: 0, // 数值，设置坐标轴标题距离坐标轴线的距离
          // 设置标题的文本样式
          textStyle: {
            textAlign: 'center', // 文本对齐方向，可取值为： start middle end
            fill: '#404040', // 文本的颜色
            fontSize: '12', // 文本大小
            fontWeight: 'bold', // 文本粗细
            rotate: 30, // 文本旋转角度，以角度为单位，仅当 autoRotate 为 false 时生效
            textBaseline: 'top' // 文本基准线，可取 top middle bottom，默认为middle
          },
          text: item.barLinePieData.xName,
          position:  'center'
        }
      });
      chart.area().position('x*y').tooltip('x*y', (x, y) => {
        y = item.barLinePieData.yName + '：' + y
        return {
          name: x,
          value: y,
        };
      });
      chart.line().position('x*y').tooltip('x*y', (x, y) => {
        y = item.barLinePieData.yName + '：' + y
        return {
          name: x,
          value: y,
        };
      });
      chart.changeSize(item.widthPX, item.heightPX)
      chart.render();
      // if(data.length>6) {
      //   const linePlot = new G2Plot.Line(document.getElementById(id), {
      //     title: {
      //       visible: false,
      //       text: '',
      //     },
      //     description: {
      //       visible: false,
      //       text: '',
      //     },
      //     width: item.widthPX,
      //     height: item.heightPX,
      //     padding: 'auto',
      //     forceFit: true,
      //     data,
      //     meta: {
      //       x: {
      //         alias: item.barLinePieData.xName,
      //       },
      //       y: {
      //         alias: item.barLinePieData.yName,
      //       }
      //     },
      //     xField: 'x',
      //     yField: 'y',
      //     xAxis: {
      //       line: {
      //         visible: true
      //       },
      //       visible: true,
      //       label: {
      //         autoHide: true,
      //         autoRotate: false,
      //       },
      //     },
      //     yAxis: {
      //       line: {
      //         visible: false
      //       },
      //       visible: true,
      //       label: {
      //         visible: true,
      //         formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
      //       },
      //     },
      //     label: {
      //       visible: true,
      //       type: 'point',
      //     },
      //     point: {
      //       visible: true,
      //       size: 3,
      //       shape: 'diamond',
      //       style: {
      //         fill: 'white',
      //         stroke: '#2593fc',
      //         lineWidth: 2,
      //       },
      //     },
      //   });
      //
      //   linePlot.render();
      // } else {
      //   const chart = new G2.Chart({
      //     container: id,
      //     autoFit: true,
      //     width: item.widthPX,
      //     height: item.heightPX,
      //     padding: 'auto'
      //   })
      //
      //   chart.data(data)
      //   chart.scale({
      //     year: {
      //       range: [0, 1],
      //     },
      //     value: {
      //       min: 0,
      //       nice: true,
      //     },
      //   })
      //   chart.tooltip({
      //     showCrosshairs: true, // 展示 Tooltip 辅助线
      //     shared: true,
      //   });
      //
      //   chart.line().position('x*y').label('value').color('#3182bd');
      //   chart.point().position('x*y');
      //
      //   chart.render()
      // }
    },
    toDecimal2NoZero(num) {
      let x = ("" + num).replace(/^\d+\./, '').length
      if(x>2) {
        num = num.toFixed(2)
      }
      return num
    },
    // 饼图
    PieBig(id, data, item, index, dray) {
      document.getElementById(id).innerHTML = ''
      let all = 0
      data.map(function(ite, ind){
        ite.y = parseFloat(ite.y)
        all = parseFloat(ite.y) + all
      })
      data.map(function(ite, ind){
        ite.percent = (parseFloat(ite.y)/all).toFixed(4)
      })
      if(this.layoutInfo[index].chartPie) {
        this.layoutInfo[index].chartPie.destroyed = true
      }
     const chart = new G2.Chart({
          container: id,
          autoFit: false,
          width: item.widthPXP,
          height: item.heightPXP,
        });
        chart.data(data);
        chart.scale('y', {
          formatter: (val) => {
            val = val * 100 + '%';
            return val;
          },
        });
        chart.coordinate('theta', {
          radius: 0.75,
        });
        // chart.legend('x', {
        //   position: 'right',
        // });
        chart.tooltip({
          showTitle: false,
          showMarkers: false,
          itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
        });
        chart.animate(true)
// 辅助文本
        chart
          .interval()
          .adjust('stack')
          .position('y')
          .color('x', ['#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864', '#8EE5B4'])
          .label('y', (y) => {
            return {
              content: (data) => {
                return '';
              },
            };
          })
          .tooltip('x*percent*y', (x, percent,y) => {
            percent = y+ ' ( '+ this.toDecimal2NoZero(percent * 100) + '%)'
            return {
              name: x,
              value: percent,
            };
          });

        chart.interaction('element')
      chart.changeSize(item.widthPX, item.heightPX)
        chart.render()
        this.layoutInfo[index].chartPie = chart

    },
    //渲染数字

  },
  mounted() {
    let that = this
    let layoutInfo = []
    let len = 0
    this.dataArr.map(function(item, index) {
      let type = item.showType
      if(type === '') {
        type = that.objArr[item.id].defaultShow
      }
      if (item.position !== '') {
        let arr = JSON.parse(item.position)
        layoutInfo.push({
          'x': arr[0],
          'y': arr[1],
          'w': arr[2],
          'h': arr[3],
          'i': JSON.parse(item.id),
          'showType': type,
          'type': item.type,
          'name': item.name,
          'ObjDate': that.objArr[item.id]
        })
      } else {
        layoutInfo.push({
          'x': 10,
          'y': 6,
          'w': 10,
          'h': 6,
          'i': JSON.parse(item.id),
          'showType': type,
          'type': item.type,
          'name': item.name,
          'ObjDate': that.objArr[item.id]
        })
      }

      len = len + 1
    })
    this.layoutInfo = layoutInfo
    if(len === this.dataArr.length) {
      this.$nextTick(() => {
        setTimeout(function() {
          that.readyRender()
        }, 500)
      })

    }
  }
}
</script>

<style scoped>
    .nojian {
        cursor: none;
        color: #e2e3e3;
    }
    .pagetion {
        padding-top: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .pagetion_2 {
        color: #333;
        font-size: 16px;
    }
    .pagetion_1 {
        font-size: 23px;

        cursor: pointer;
    }
    .fixIcone {
        display: none;
        position: absolute;
        bottom: 5px;
        right: 0;
        font-size: 16px;
        width: 25px;
        height: 20px;
        line-height: 25px;
    }
    .fixIcone img {
        width: 15px;
        height: auto;
    }
    .item-contentTest:hover {
        -moz-box-shadow:0px 5px 10px 5px rgba(217,217,217,0.5);
        -webkit-box-shadow:0px 5px 10px 5px rgba(217,217,217,0.5);
        box-shadow:0px 5px 10px 5px rgba(217,217,217,0.5);
    }
    .item-contentTest:hover .fixIcone {
        display: block;
    }
    .item-contentTest:hover .button-content{
        display: block;
    }
    .board_blank {
        background-color: #fff;
        cursor: pointer;
        width: 300px;
        height: 300px;
        display: flex;
        margin: 10px 25px;
        justify-content: center;
        align-items: center;
        text-align: center;
        background-color: #fff;
    }
    .board_blank i {
        color: #1980ff;
        font-size: 25px;
    }
    .table-div {
        width: 100%;
        overflow: auto;
        height: 100%;
        background-color: #fff;
    }
    .singleNum {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .singleNum_2 {
        font-weight: bold;
        font-size: 40px;
        color: #1980FF;
    }
    .bigCont {
        padding: 0 20px;
    }
    .bigTitletop {
        height: 45px;
        line-height: 45px;
        padding: 0 10px;
        position: relative
    }
    .chart-title {
        text-align: left;
        padding-left: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 70px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    .button-content >i {
        margin-left: 6px;
    }
</style>
